import React, {Component} from 'react'
import {withRouter} from 'react-router-dom'
import {observer, inject} from 'mobx-react'
import {reaction} from 'mobx'
import {EditorState} from 'draft-js'
import {notification} from 'antd'

import AutocompleteEditor from './Autocomplete'
import Modal from './Modal'
import {decorateIndicators, decorateComparison, decorateConjunctions, decorateTriggers, decorateSymbols} from './decorators'

import * as triggers from './triggers'
import addSuggestion from './functions/addsuggestion'
import {filterArray, findAncestor} from './functions/utils'

import style from './style.sass'

let filteredArrayTemp

@withRouter
@inject('store') @observer
class Signal extends Component {
  state = {
    editorState: EditorState.createEmpty(),
    decorators: {},
    autocompleteState: null,
    focus: false,
    modal: false
  }
  componentDidMount() {
    const {symbols, algo} = this.props.store

    this.updateSymbols()
    this.disposer = reaction(
      () => algo.single.data.has_coin,
      () => {
        this.updateTriggers()
        symbols.reset('symbols')
        this.updateSymbols()
      }
    )

    symbols.search('', 2)

    const {has_coin} = algo.single.data

    const comparisonDecorator = decorateComparison()
    const conjunctionDecorator = decorateConjunctions()
    const triggerDecorator = decorateTriggers(has_coin)
    this.decorate({comparisonDecorator, conjunctionDecorator, triggerDecorator})
    this.highlightIndicators()
  }
  componentWillUnmount() {
    this.disposer()
  }
  handleAutocompleteChange = (autocompleteState) => {
    this.setState({autocompleteState})
  }
  handleBeforeInput = (chars, editorState) => {
    const selection = editorState.getSelection()
    const content = editorState.getCurrentContent()

    const block = content.getBlockForKey(selection.getAnchorKey())
    const end = selection.getEndOffset()
    const text = block.getText()
    const sliced = text.slice(0, end)

    if (chars.match(/\s/)) {
      let start = sliced.lastIndexOf(' ') + 1
      const lastWord = sliced.slice(start).trim()
      if (lastWord) {
        this.checkIfSymbol(lastWord)
      }
    }
  }

  highlightIndicators = async () => {
    const {signal} = this.props.store
    try {
      await signal.getParts()
      let array = []
      signal.indicators.map(row => {
        array.push(row.syntax.replace(/\s/g, '\\s+'))
      })
      signal.fundamentals.map(row => {
        array.push(row.syntax.replace(/\s/g, '\\s+'))
      })
      signal.alternatives.map(row => {
        array.push(row.syntax.replace(/\s/g, '\\s+'))
      })

      const indicatorsDecorator = decorateIndicators(array)
      this.decorate({indicatorsDecorator})
    } catch (e) {
      notification['error']({
        message: 'Failed to get signal parts'
      })
    }
  }

  checkIfSymbol = (word) => {
    const {symbols} = this.props.store
    symbols.isSymbol(word).then((result) => {
      if (!result) {
        return
      }
      this.highlightSymbols()
    })
  }

  decorate = (decoratorsObj) => {
    const decorators = Object.assign(this.state.decorators, decoratorsObj)
    this.setState({decorators})
    this.props.store.algo.single[this.props.name].decorate(decorators)
  }

  updateSymbols = () => {
    const arr = this.props.store.algo.single.data[this.props.name]?.split(/\s/)
    if (!arr?.length) {
      return
    }
    const checkSymbols = arr.map(word => this.props.store.symbols.isSymbol(word))
    Promise.all(checkSymbols).then(() => {
      this.highlightSymbols()
    })
  }

  highlightSymbols = () => {
    const {symbolsRegex} = this.props.store.symbols
    const symbolsDecorator = decorateSymbols(symbolsRegex)
    this.decorate({symbolsDecorator})
  }

  updateTriggers = () => {
    const {has_coin} = this.props.store.algo.single.data
    const triggerDecorator = decorateTriggers(has_coin)
    this.decorate({triggerDecorator})
  }

  handleInsert = (insertState) => {
    if (!filteredArrayTemp) {
      return null
    }
    const array = insertState.text.split(' ')
    array.map(word => this.checkIfSymbol(word))
    const editorState = addSuggestion(insertState)
    this.props.store.algo.single[this.props.name].change(editorState)
    setTimeout(() => {
      this.editor.focusEditor()
      this.setState({focus: true, autocompleteState: null, modal: false})
    },0)
  }

  handlePastedText = (text) => {
    const array = text.split(' ')
    array.map(word => this.checkIfSymbol(word))
  }

  getFilteredArray(type, text) {
    const store = this.props.store.signal
    let dataArray
    switch (type) {
    case triggers.INDICATOR:
      dataArray = store.indicators.map(row => row.syntax)
      break
    case triggers.FUNDAMENTAL:
      dataArray = store.fundamentals.map(row => row.syntax)
      break
    case triggers.ALTERNATIVE:
      dataArray = store.alternatives.map(row => row.syntax)
      break
    }
    const filteredArray = filterArray(dataArray, text.replace(triggers.regExByType(type), ''))
    return filteredArray
  }

  handleFocus = () => {
    this.props.store.algo.single.removeError(this.props.name)
    this.setState({focus: true})
  }
  handleBlur = (e) => {
    if (findAncestor(e.relatedTarget, this.wrapper)) {
      return
    }
    this.setState({focus: false})

    if (!this.state.modal) {
      this.props.store.algo.validateSignal(this.props.name)
    }

  }

  showModal = () => {
    this.setState({modal:true})
  }
  hideModal = () => {
    this.setState({modal:false})
  }

  render() {
    const {editorState, autocompleteState, focus} = this.state

    const hasErrors = this.props.store.algo.single.errors[this.props.name]

    if (autocompleteState) {
      filteredArrayTemp = this.getFilteredArray(autocompleteState.type, autocompleteState.text)
      autocompleteState.array = filteredArrayTemp
      autocompleteState.onSuggestionClick = this.onSuggestionItemClick
    }
    return(
      <div
        styleName='wrapper'
        ref={el => this.wrapper = el}
      >
        <AutocompleteEditor
          name={this.props.name}
          editorState={editorState}
          autocompleteState={autocompleteState}
          handleChange={this.handleChange}
          onAutocompleteChange={this.handleAutocompleteChange}
          handleBeforeInput={this.handleBeforeInput}
          handlePastedText={this.handlePastedText}
          onInsert={this.handleInsert}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          focus={focus}
          hasErrors={hasErrors}
          showModal={this.showModal}
          onRef={ref => this.editor = ref}
        />
        <Modal visible={this.state.modal} hide={this.hideModal}/>
      </div>
    )
  }
}

export default Signal
